import { getActiveDirectors, getActiveMembers } from '../../sgDocGenEntityApi';
import { dedupePresetSigners } from '../../presetSignerDedup';

function trim(v: unknown): string {
  return v === null || v === undefined ? '' : String(v).trim();
}

function toSignerJson(
  items: Array<{ name: string; email?: string; role?: string; contactCd?: string; contactRegNo?: string }>,
): string {
  const list = dedupePresetSigners(items);
  return list.length > 0 ? JSON.stringify(list) : '';
}

export async function buildDirectorsSignersJson(entityCd: string): Promise<string> {
  if (!trim(entityCd)) return '';
  try {
    const res: any = await getActiveDirectors(entityCd);
    const directors = res?.data?.directors || [];
    return toSignerJson(
      directors.map((d: any) => ({
        name: d?.name || d?.contactName || '',
        email: d?.contactEmail || d?.email || '',
        contactCd: d?.contactCd || d?.CONTACT_CD || '',
        contactRegNo: d?.contactRegNo || d?.CONTACT_REG_NO || d?.contactIdUen || '',
        role: 'director',
      })),
    );
  } catch (e) {
    console.warn('[allotmentSigners] getDirectors failed:', e);
    return '';
  }
}

export async function buildMembersSignersJson(entityCd: string): Promise<string> {
  if (!trim(entityCd)) return '';
  try {
    const res: any = await getActiveMembers(entityCd);
    const members = res?.data?.members || [];
    return toSignerJson(
      members.map((m: any) => ({
        name: m?.name || m?.contactName || `${m?.firstName || ''} ${m?.surname || m?.lastName || ''}`.trim(),
        email: m?.contactEmail || m?.email || '',
        contactCd: m?.contactCd || m?.CONTACT_CD || '',
        contactRegNo: m?.contactRegNo || m?.CONTACT_REG_NO || m?.contactIdUen || '',
        role: 'member',
      })),
    );
  } catch (e) {
    console.warn('[allotmentSigners] getMembers failed:', e);
    return '';
  }
}

export function buildSingleAllotteeSignerJson(input: {
  categoryCd: string;
  allotteeName: string;
  representativeName?: string;
}): string {
  const isCorporate = trim(input.categoryCd) === 'B09001';
  const name = isCorporate ? trim(input.representativeName) || trim(input.allotteeName) : trim(input.allotteeName);
  return toSignerJson([{ name, role: 'signer' }]);
}
